import { Color } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'stretch',
  },
  block: {
    flex: 1,
    flexDirection: 'row',
  },
  time: {
    flex: 2,
    backgroundColor: Color.sleepingGrey,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: Color.sleepingGrey,
    borderRadius: 1,
  },
  timeFirst: {
    borderTopStartRadius: 0,
    borderBottomStartRadius: 0,
  },
  timeLast: {
    borderTopEndRadius: 0,
    borderBottomEndRadius: 0,
  },
  space: {
    flex: 1,
  },
  spaceSelected: {
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: Color.calmGrey,
  },
})

interface Props extends ViewProps {
  colors?: string[]
}
const ScheduleSelection = (props: Props) => {
  const { colors, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {colors?.map((item, index) => {
        const color = item || Color.sleepingGrey
        const timeStyle = [
          styles.time,
          item && {
            backgroundColor: color,
            borderColor: color,
          },
          colors[index - 1] && styles.timeFirst,
          colors[index + 1] && styles.timeLast,
        ]
        const spaceStyle = [styles.space, item && colors[index + 1] && styles.spaceSelected]
        return (
          <View style={styles.block} key={`day-${index}`} testID="ScheduleSelection.Block">
            <View style={timeStyle} />
            <View style={spaceStyle} />
          </View>
        )
      })}
    </View>
  )
}

export default ScheduleSelection
